import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { getSecondaryText } from "@multiweb/reactCore/i18n";
import { IconCode } from "@multiweb/types/contracts";
import { IAppState } from "@multiweb/types/react";
import { createMenuItemActivatedAction } from "../../actions";
import { LOC_KEY_ACTION_ITEM_OPEN_FORM_IN_TAB } from "../../locKeys";
import { createActionItemFocusedAction, createFocusableItemId, isItemFocused, MenuFocusableItemType, NavigationSection } from "../../navigation";
import { MenuItemActivatedType } from "../../types";
import { createMenuItemKeyActivationHandler, createMenuItemMouseActivationHandler } from "../../utils";
import { ActionItemComponent, ActionItemComponentProps } from "../ActionItemComponent";

export type OpenInTabActionItemActivatableTypes = MenuItemActivatedType.openFormInTabActionItem
    | MenuItemActivatedType.openProfileInTabActionItem
    | MenuItemActivatedType.openFormInstanceInTabActionItem;

export type OpenInTabActionItemProps = {
    /**
     * Id položky, kterou akční položka otvírá. Unikátní v rámci aktivovatelného typu. Pro otevřené instance formulářů je typ string, pro formulářové položky menu
     * a profily je typ number.
     */
    itemId: string | number;
    /**
     * Typ aktivovatelné položky, kterou reprezentuje tato akční položka.
     */
    activatableItemType: OpenInTabActionItemActivatableTypes;
    /** Sekce, ve které je položka vykreslená. Slouží pro určování zaměření. */
    section: NavigationSection;
    /** Příznak, zda se má použít barva pozadí pro submenu. */
    hasSubmenuBackground?: boolean;
    /** Příznak, zda má tlačítko vypadat jako po najetí myši. */
    isActive?: boolean;
};

type StateProps = {
    title: string | undefined;
    isFocused: boolean;
};

const mapStateToProps: MapStateToProps<StateProps, OpenInTabActionItemProps, IAppState> = (state, { itemId, section }) => ({
    title: getSecondaryText(state, LOC_KEY_ACTION_ITEM_OPEN_FORM_IN_TAB),
    isFocused: isItemFocused(state, { itemId, type: MenuFocusableItemType.openInTabActionItem, section }),
});

type DispatchProps = {
    actionActivated: typeof createMenuItemActivatedAction;
    actionItemFocused: typeof createActionItemFocusedAction;
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OpenInTabActionItemProps> = {
    actionActivated: createMenuItemActivatedAction,
    actionItemFocused: createActionItemFocusedAction,
};

const mergeProps: MergeProps<StateProps, DispatchProps, OpenInTabActionItemProps, ActionItemComponentProps> = (
    { title, isFocused },
    { actionActivated, actionItemFocused },
    { itemId, activatableItemType, isActive, hasSubmenuBackground, section },
) => ({
    onClick: createMenuItemMouseActivationHandler(itemId, activatableItemType, section, actionActivated),
    onKeyUp: createMenuItemKeyActivationHandler(itemId, activatableItemType, section, actionActivated),
    iconCode: IconCode.uiOutLink,
    title,
    isFocused,
    isActive,
    hasSubmenuBackground,
    actionItemFocused: () => actionItemFocused(createFocusableItemId(itemId, MenuFocusableItemType.openInTabActionItem, section)),
});

export const OpenInTabActionItem = connect(mapStateToProps, mapDispatchToProps, mergeProps)(ActionItemComponent);
